import * as React from 'react';
import './FilterSelectionFeedback.scss';

export class FilterSelectionFeedback extends React.Component<
    {
        filtersCount: number;
        onClearFilters: () => void;
        showDefaultText?: boolean;
    },
    {}
> {
    static defaultProps = {
        showDefaultText: true,
    };

    render() {
        const { filtersCount, onClearFilters } = this.props;

        if (filtersCount > 0) {
            return (
                <div
                    className='panel-selection-feedback flex-row'
                    style={{ margin: '-2px 0 -2px 0', gap: 10 }}
                    title={kuura.getMessage('js_map.available_items_below_are_limited_by_filters')}
                >
                    <span>{filtersCount === 1 ? kuura.getMessage('general.1_filter_applied') : kuura.getMessage('general.n_filters_applied', filtersCount)}</span>
                    <span className='button clear-selection' onClick={onClearFilters}>
                        {kuura.getMessage('general.clear_filters')}
                    </span>
                </div>
            );
        }

        return this.props.showDefaultText ? __('general.filters') : null;
    }
}
